import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function southZoneOffice() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>
                          DIVISIONAL / REGIONAL SALES OFFICES, SOUTH - ZONE
                          (HYDERABAD)
                        </h2>
                        <div class="clearfix"></div>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col">SL. No.</th>

                              <th scope="col">Name</th>

                              <th scope="col">Designation</th>

                              <th scope="col">Area of Operation</th>

                              <th scope="col">Telephone</th>

                              <th scope="col">Fax</th>

                              <th scope="col">E-mail ID</th>

                              <th scope="col">Address</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td>1</td>

                              <td>Shri. Mukul Mathur</td>

                              <td>Additional Charge</td>

                              <td>
                                South Zone, AP, Telangana, Karnatka, Kerla,
                                Tamilnadu, Puducherry, Lakshdeep, Cuttack
                              </td>

                              <td>040-23074804</td>

                              <td>040-23074814</td>

                              <td>
                                <a href="mailto:Idplmukul2018@gmail.com">
                                  Idplmukul2018@gmail.com
                                </a>
                              </td>

                              <td>
                                IDPL, Administrative Block, Ground Floor,
                                Balanagar, Hyderabad – 500037 (A.P.)
                              </td>
                            </tr>

                            <tr>
                              <td>2</td>

                              <td>Shri. Mukul Mathur</td>

                              <td>Additional Charge</td>

                              <td>Tamilnadu, Puducherry, Kerla</td>

                              <td>044-26541678</td>

                              <td>044-22321802</td>

                              <td>
                                <a href="mailto:Idplmukul2018@gmail.com">
                                  Idplmukul2018@gmail.com
                                </a>
                              </td>

                              <td>
                                IDPL. (TN) Complex, Nandambakam Chennai-600089
                              </td>
                            </tr>

                            <tr></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
